module.exports = __webpack_public_path__ + "img/INF-i-1-III.28abbc40.png";